// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cbp-icon-circle{display:inline-flex;justify-content:center;align-items:center;width:48px;height:48px;border-radius:50%}", ""]);
// Exports
module.exports = exports;
